class UnionsModel{
    unionId:number;
    name?: string;
    shortName?: string;
    address?:string;
    
}
export default UnionsModel;